import { useEffect } from 'react';
import { useAuthStore } from './auth.store';

export const useSyncAuthWithContext = ({ activeToken }: { activeToken: string | null }) => {
  const setActiveToken = useAuthStore((s) => s.setActiveToken);

  useEffect(() => {
    setActiveToken(activeToken);
  }, [activeToken, setActiveToken]);
};
